import { formErrorAnatomy as parts } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'
import { textStyles } from '../foundations'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  text: defineStyle({
    ...textStyles.sm,
  }),
})

export const FormError = defineMultiStyleConfig({
  baseStyle,
})
